import { Link } from "react-router-dom";
import "./politicasdeprivacidad.css";

function PoliticasDePrivacidad() {
  return (
    <div className="privacy-container container my-5">
      <h1 className="privacy-title text-center mb-3">Políticas de Privacidad</h1>
      <p className="privacy-intro text-center text-muted mb-5">
        Working Unidos recopila y utiliza datos personales de acuerdo con nuestra Política de Privacidad. 
        Al utilizar nuestros servicios, aceptas que tus datos sean tratados conforme a dicha política.
      </p>

      <h2>1. Propiedad Intelectual</h2>
      <ul className="privacy-list">
        <li>
          Todo el contenido de Working Unidos, incluyendo logos, marcas, diseño y software, es propiedad exclusiva de la plataforma o sus licenciantes.
        </li>
        <li>
          Los usuarios no tienen derecho a copiar, distribuir, modificar o crear trabajos derivados del contenido sin autorización expresa por escrito.
        </li>
      </ul>

      <h2>2. Limitación de Responsabilidad</h2>
      <p>Working Unidos no será responsable por:</p>
      <ul className="privacy-list">
        <li>Pérdidas indirectas o consecuentes derivadas del uso de la plataforma.</li>
        <li>
          Retrasos o interrupciones en la prestación de servicios debido a causas fuera de nuestro control (fallos técnicos, fuerza mayor).
        </li>
        <li>
          La exactitud de la información publicada por empleadores o usuarios en la plataforma.
        </li>
      </ul>

      <h2>3. Modificaciones a los Términos</h2>
      <p>
        Working Unidos se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. 
        Las modificaciones serán notificadas a los usuarios y el uso continuado de la plataforma implicará la aceptación de los términos modificados.
      </p>

      <h2>4. Terminación de Cuenta</h2>
      <p>Podemos suspender o cancelar tu cuenta en Working Unidos si:</p>
      <ul className="privacy-list">
        <li>Incumples estos términos.</li>
        <li>Realizas actividades ilegales o fraudulentas en la plataforma.</li>
        <li>Usas la plataforma de forma que perjudique a otros usuarios o a Working Unidos.</li>
      </ul>

      <h2>5. Ley Aplicable y Jurisdicción</h2>
      <p>
        Estos términos y condiciones se regirán por las leyes aplicables en Washington DC, EE.UU., y cualquier disputa que surja en relación con los mismos será resuelta exclusivamente en los tribunales estatales o federales de Washington DC. 
        Si accedes a nuestros servicios desde fuera de los Estados Unidos, aceptas cumplir con las leyes locales de tu país de residencia. 
        Working Unidos no garantiza que los servicios ofrecidos sean apropiados o legales en otras jurisdicciones. 
        El uso de la plataforma en otros países se realiza bajo tu propia responsabilidad de cumplir con las leyes locales.
      </p>

      <h2>6. Derechos de los Consumidores Internacionales</h2>
      <p>
        Si accedes a la plataforma desde países fuera de EE.UU., reconoces que algunos derechos adicionales de protección al consumidor pueden aplicarse bajo las leyes de tu país de residencia. 
        Working Unidos cumplirá con dichas leyes en la medida en que no entren en conflicto con las leyes de Washington DC.
      </p>

      <h2>7. Resolución de Disputas</h2>
      <p>
        Antes de llevar cualquier disputa a los tribunales, las partes acuerdan intentar resolverla mediante mediación o arbitraje. 
        Cualquier controversia no resuelta a través de la mediación será resuelta en los tribunales de Washington DC.
      </p>

      <h2>8. Contacto</h2>
      <p>
        Si tienes preguntas sobre estos términos, puedes contactarnos a través de:
      </p>
      <ul className="privacy-list">
        <li>Correo electrónico: [correo de contacto]</li>
        <li>Teléfono: [número de teléfono]</li>
        <li>Dirección: [dirección física]</li>
      </ul>

      <h2>15. Aceptación de los Términos</h2>
      <p>
        Al continuar utilizando Working Unidos, reconoces que has leído, comprendido y aceptado estos Términos y Condiciones.
      </p>

      {/* Botón de regresar */}
      <div className="text-center mt-4">
        <Link to="/register" className="register-btn">
          Regresar
        </Link>
      </div>
    </div>
  );
}

export default PoliticasDePrivacidad;